import React from 'react';
import {BrowserRouter as Router, Routes, Navigate, Route} from "react-router-dom";
import SaleOrderAjaxCart from "./components/SaleOrderAjaxCart";
import SaleOrderAjaxWishList from "./components/SaleOrderAjaxWishList";
import SaleOrderAjaxSuccess from "./components/SaleOrderAjaxSuccess";
import Stub from "./components/Stub/Stub";

// import {number_format} from "./components/Functions/NumberFormat";

class SaleOrderAjax extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			preloader: true,
			wishList: [],
			basketItems: [],
			orderProps: [],
			totalPrice: 0,
			deliveryPrice: 600 //Если totalPrice > 9000 - 0;
		};
		
		this.zeroPrice = 'Цена по запросу';
		this.freeDelivery = 0;
		this.orderSuccess = false;
		this.contactPhone = '+7 (495) 215-29-17';
		
		this.server = (window.location.hostname === 'localhost') ? process.env.REACT_APP_SERVER : '';
		this.timer = false;
		
		this._onChangeBasketHandle = this._onChangeBasketHandle.bind(this);
		this._onMoveToBasket = this._onMoveToBasket.bind(this);
		this._onRemoveWishListItem = this._onRemoveWishListItem.bind(this);
		this._onRemoveBasketItem = this._onRemoveBasketItem.bind(this);
		this._onOrder = this._onOrder.bind(this);
		
	}
	
	componentDidMount() {
		fetch(this.server + '/ajax/react/sale.order.ajax.php', {
			method: 'post',
			credentials: 'include',
			body: JSON.stringify({action: 'getItems'})
		})
			.then(res => res.json())
			.then(json => {
					this.setState({
						preloader: false,
						wishList: json.wishList,
						basketItems: json.basketItems,
						orderProps: json.orderProps,
						totalPrice: json.totalPrice,
						deliveryPrice: (json.totalPrice > this.freeDelivery) ? 0 : 600
					});
				}
			)
	}
	
	_onOrder(event, token) {
		event.preventDefault();
		
		let submitButton = document.getElementById('submitOrderButton');
		if (submitButton.classList.contains('busy')) return false;
		submitButton.classList.add('busy');
		
		let formData = new FormData(event.target);
		formData.append('g-recaptcha-response-v3', token)
		
		const {orderProps} = this.state;
		
		let success = true;
		for (let prop of orderProps.items) {
			// console.log({prop});
			if (prop.req === 'Y' && prop.all.ACTIVE === 'Y') {
				let field = document.getElementById(prop.property_id);
				if (field.value.length > 0) field.classList.remove('is-error');
				else {
					success = false;
					field.classList.add('is-error');
				}
			}
		}
		
		if (success && !this.orderSuccess) {
			this.orderSuccess = true;
			
			fetch(process.env.REACT_APP_SERVER + '/ajax/order.php', {
				credentials: 'include',
				method: 'POST',
				body: formData
			})
				.then(res => res.json())
				.then(json => {
					if ('undefined' === typeof json.error) {
						if (undefined !== json.success) {
							let order_id;
							if (undefined !== typeof json.redirect) {
								order_id = json.redirect.replace(/[\W+a-zA-Z_]+/g, '');
							} else {
							
							}
							const date = new Date();
							const month = date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
							sessionStorage.setItem('date', date.getDate() + '.' + month + '.' + date.getFullYear());
							sessionStorage.setItem('orderId', order_id);
							sessionStorage.setItem('customerName', formData.get('ORDER_PROP_1'));
							// alert('ostonovis mgnovenye - ti debazhno');
							window.location.href = "/cart/success/" + order_id + "/"
						} else {
							alert("При оформлении заказа произошла ошибка. Обратитесь к нашим менеджерам по телефону " + this.contactPhone);
							this.orderSuccess = false;
							submitButton.classList.remove('busy');
						}
					} else {
						alert(json.error);
					}
				})
			;
		}
		if (!this.orderSuccess) submitButton.classList.remove('busy');
		
	}
	
	_onRemoveBasketItem(id) {
		let {basketItems} = this.state;
		let totalPrice = 0;
		let deliveryPrice;
		
		let needleItem;
		
		for (let i in basketItems) {
			if (basketItems[i].id === id) {
				needleItem = i;
			} else {
				totalPrice += basketItems[i].price * basketItems[i].quantity;
			}
		}
		
		fetch(this.server + '/ajax/react/sale.order.ajax.php', {
			method: 'post',
			credentials: 'include',
			body: JSON.stringify({
				action: 'delete',
				id: id
			})
		}).then(res => res.json());
		
		basketItems.splice(needleItem, 1);
		
		deliveryPrice = (totalPrice > this.freeDelivery) ? 0 : 600;
		
		this.setState({basketItems, totalPrice, deliveryPrice});
	}
	
	_onChangeBasketHandle(value, index) {
		index = index.toString();
		let basketItems = this.state.basketItems;
		let totalPrice = 0;
		let deliveryPrice = 0;
		
		for (let i in basketItems) {
			if (i === index) {
				basketItems[index].quantity = value;
			}
			
			totalPrice += basketItems[i].price * basketItems[i].quantity;
		}
		
		deliveryPrice = (totalPrice > this.freeDelivery) ? 0 : 600;
		
		clearTimeout(this.timer);
		
		this.timer = setTimeout(() => {
			fetch(this.server + '/ajax/react/sale.order.ajax.php', {
				method: 'post',
				credentials: 'include',
				body: JSON.stringify({
					action: 'updateQuantity',
					id: basketItems[index].id,
					value: value,
				})
			}).then(res => res.json());
		}, 300);
		
		this.setState({basketItems, totalPrice, deliveryPrice});
	}
	
	_onMoveToBasket(id) {
		let {wishList, basketItems} = this.state;
		let totalPrice = 0;
		let deliveryPrice = 0;
		let i;
		
		for (i in wishList) {
			if (wishList[i].id === id) {
				
				fetch(this.server + '/ajax/react/sale.order.ajax.php', {
					method: 'post',
					credentials: 'include',
					body: JSON.stringify({
						action: 'moveToBasket',
						id: id
					})
				}).then(res => res.json());
				
				basketItems.push(wishList[i]);
				wishList.splice(i, 1);
				break;
			}
		}
		
		for (i in basketItems) {
			totalPrice += basketItems[i].price * basketItems[i].quantity;
		}
		
		deliveryPrice = (totalPrice > this.freeDelivery) ? 0 : 600;
		
		this.setState({wishList, basketItems, totalPrice, deliveryPrice});
	}
	
	_onRemoveWishListItem(id) {
		let {wishList} = this.state;
		
		for (let i in wishList) {
			if (wishList[i].id === id) {
				
				fetch(this.server + '/ajax/react/sale.order.ajax.php', {
					method: 'post',
					credentials: 'include',
					body: JSON.stringify({
						action: 'delete',
						id: id
					})
				}).then(res => res.json());
				
				wishList.splice(i, 1);
				break;
			}
		}
		
		this.setState({wishList});
	}
	
	render() {
		if (this.state.preloader) {
			return (
				<div id="preloader">
					<div/>
				</div>
			)
		} else {
			const basketItems = this.state.basketItems.length;
			const wishListItems = this.state.wishList.length;
			
			return (
				<Router>
					<Routes>
						<Route path="/cart/"
						       element={<SaleOrderAjaxCart
							       wishList={this.state.wishList}
							       basketItems={this.state.basketItems}
							       orderProps={this.state.orderProps}
							       totalPrice={this.state.totalPrice}
							       zeroPrice={this.zeroPrice}
							       deliveryPrice={this.state.deliveryPrice}
							       _onChangeBasketHandle={(value, index) => this._onChangeBasketHandle(value, index)}
							       _onRemoveBasketItem={id => this._onRemoveBasketItem(id)}
							       _onOrder={this._onOrder}/>}
						></Route>
						<Route
							path="/cart/wishlist/"
							element={<SaleOrderAjaxWishList wishList={this.state.wishList}/>}
						/>
						<Route path="/cart/success/:orderId/" element={<SaleOrderAjaxSuccess/>}/>
						
						
						<Route path="/catalog/" element={<Stub/>}/>
						<Route path="*" element={<main style={{padding: "1rem"}}>
							<p>There's nothing here!</p>
						</main>}/>
						
						
						{/*<Route path="*" element={<Navigate to={"/cart/"} />}/>*/}
					</Routes>
				</Router>
			)
		}
	}
}


export default SaleOrderAjax;